import React from 'react';

const Contact = () => {
    return (
        <div style={{height:'100%', width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'150px'}}>
            Contact page is under Development
        </div>
    );
}

export default Contact;
